// extracted by mini-css-extract-plugin
export var filterIncDec = "_e2-0";
export var leftBorder = "_e2-1";
export var rightBorder = "_e2-2";
export var stringInput = "_e2-3";